import { Typography } from '@mui/material';
import { IS_ONCE_PH_PORTAL } from 'config';
import OnceLogo from "assets/images/OnceLogo.png";

type AppLogoType = {
  hideName?: boolean;
  style?: React.CSSProperties;
};

export function AppLogo({ hideName, style }: AppLogoType) {
  return (
    <div style={{ ...style, display: 'flex', alignItems: 'center' }}>
      <div
        style={{
          marginRight: hideName ? 0 : 8,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        {IS_ONCE_PH_PORTAL ? <img src={OnceLogo} alt="logo" style={{ height: "50px" }} /> :
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.19947 14.3269C7.99701 14.5361 10.5146 15.7584 12.383 17.6304C13.0687 18.3167 13.6692 19.0924 14.1621 19.935V17.0579C13.8903 15.3056 13.162 13.7076 12.103 12.3858C10.8514 10.8244 9.14118 9.6467 7.17742 9.06193C6.05151 10.5442 5.33539 12.3553 5.19947 14.3269ZM8.21613 7.90051C10.2002 8.6193 11.9245 9.8741 13.2168 11.4883C13.5637 11.9208 13.8801 12.3817 14.1621 12.8629V5.21626C11.8636 5.41118 9.79038 6.39595 8.21613 7.90051ZM15.8358 5.21626V12.8629C16.1178 12.3817 16.4343 11.9228 16.7812 11.4883C18.0734 9.8741 19.7998 8.6193 21.7839 7.90051C20.2096 6.39595 18.1363 5.40915 15.8378 5.21626H15.8358ZM22.8205 9.06193C20.8568 9.6467 19.1466 10.8223 17.8949 12.3858C16.836 13.7076 16.1076 15.3056 15.8358 17.0579V19.935C16.3288 19.0904 16.9292 18.3167 17.6149 17.6304C19.4833 15.7604 22.001 14.5381 24.7985 14.3269C24.6626 12.3553 23.9465 10.5442 22.8205 9.06193ZM24.7944 15.7665C22.3945 15.9736 20.238 17.0335 18.6293 18.6437C17.1747 20.0995 16.1685 22.0061 15.8358 24.134V24.8061C18.2154 24.6051 20.3537 23.5553 21.9462 21.9614C23.5569 20.3492 24.6119 18.1787 24.7944 15.7645V15.7665ZM14.1642 24.134C13.8315 22.0041 12.8253 20.0995 11.3707 18.6437C9.76199 17.0335 7.60548 15.9736 5.20556 15.7665C5.38814 18.1807 6.44306 20.3513 8.05382 21.9635C9.64633 23.5574 11.7845 24.6071 14.1642 24.8081V24.134ZM0 15.0112C0 18.8528 1.46468 22.6964 4.39206 25.6264C7.10845 28.3452 10.6079 29.803 14.1621 30V26.4853C11.32 26.2802 8.76587 25.0437 6.87109 23.1452C4.7917 21.064 3.50352 18.1868 3.50352 15.0091C3.50352 11.8315 4.78967 8.95634 6.87109 6.87309C8.95048 4.79187 11.8251 3.50254 15 3.50254C18.1749 3.50254 21.0475 4.78984 23.1289 6.87309C25.2083 8.95431 26.4965 11.8315 26.4965 15.0091C26.4965 18.1868 25.2103 21.0619 23.1289 23.1452C21.2341 25.0416 18.678 26.2802 15.8378 26.4853V30C19.3941 29.803 22.8936 28.3452 25.6079 25.6264C28.5353 22.6964 30 18.8528 30 15.0112C30 11.1696 28.5353 7.32589 25.6079 4.39594C22.6806 1.46599 18.8403 0 15.002 0C11.1638 0 7.3235 1.46599 4.39612 4.39594C1.46874 7.32589 0.00406131 11.1696 0.00406131 15.0112H0Z"
              fill={style?.fill ?? '#F4F4F4'}
            />
          </svg>
        }
      </div>
      {!hideName ? (
        <Typography fontSize={style?.fontSize ?? '28px'} color={style?.fill}>
          Policyholder
        </Typography>
      ) : null}
    </div>
  );
}
